// PharmWealth Logo Component
import React from 'react';

const PharmWealthLogo = ({ size = 'full', showText = true }) => {
  const isCompact = size === 'compact';
  
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: isCompact ? '8px' : '12px'
    }}>
      <img 
        src="/pharmwealth-logo.png" 
        alt="PharmWealth Ventures" 
        style={{
          height: isCompact ? '48px' : '180px',
          width: 'auto',
          objectFit: 'contain',
          filter: 'drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1))'
        }}
      />
      
      {/* Text */}
      {showText && !isCompact && (
        <div style={{ textAlign: 'center' }}>
          <div style={{
            fontSize: '1.125rem',
            fontWeight: 'bold',
            background: 'linear-gradient(135deg, #C6A34F 0%, #D4B86A 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            letterSpacing: '0.05em',
            lineHeight: '1.2'
          }}>
            PHARMWEALTH
          </div>
          <div style={{
            fontSize: '0.75rem',
            color: '#C6A34F',
            letterSpacing: '0.1em',
            fontWeight: '500',
            textTransform: 'uppercase'
          }}>
            VENTURES
          </div>
        </div>
      )}
    </div>
  );
};

export default PharmWealthLogo;

